/** @jsxImportSource @emotion/react */

import React from 'react';
import { v4 as uuid4 } from 'uuid';
import styled from 'styled-components';
import Scroll from '@component/common/scroll';
import * as size from '@constant/size';
import * as color from '@constant/color';
import { useTypedDispatch } from '@hook/common/useStore';
import { useMySubscriptionsQuery, useMyShelvesQuery } from '@hook/moashelf/useApi';
import { ISubscriptionData } from '@datatype/moashelf/api-type';
import { isMobile } from 'react-device-detect';
import SubscriptionItem from '@component/moashelf/newsletter/subscriptions/subscription-item';
import * as text from '@constant/text';
import TextBlock from '@component/common/block/text-block';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import { IMoashelfMenu } from '@datatype/moashelf/type';

interface IProps {
  mode: IMoashelfMenu['subscription'];
}

const Wrapper = styled.div`
  height: 100%;
`;

const SubscriptionItemsContainer = styled.div`
  width: 100%;
  // margin: ${size.MARGIN_2} auto 0 auto;
  //border: ${size.BORDER_WIDTH_1} solid ${color.GRAY_3};
  border-radius: ${size.BORDER_RADIUS_3};
`;

const TEXT_DESIGN = {
  text: { size: IS_IYAGIGO_MOBILE_VIEW ? 'medium' : 'medium', color: color.BLACK_2, bold: false },
  box: { alignX: 'left', margin: `${size.MARGIN_2} 0 0 ${size.MARGIN_2}` },
} as const;

const Subscriptions: React.FC<IProps> = ({ mode }) => {
  const dispatch = useTypedDispatch();
  const query = useMySubscriptionsQuery(mode, 1, 50);
  const subscriptions = (query.data?.data || []) as ISubscriptionData[];

  let notificationText;

  switch (mode) {
    case 'subscription-all':
      notificationText = '구독하는 뉴스레터가 없습니다. 🙂';
      break;
    case 'subscription-trash':
      notificationText = '구독해제한 뉴스레터가 없습니다. 🙂';
      break;
    default:
      notificationText = '';
      break;
  }

  const SubscriptionItems = subscriptions
    .filter((subscription) => {
      if (mode === 'subscription-all') return !subscription.trashedAt;
      if (mode === 'subscription-trash') return !!subscription.trashedAt;
      return true;
    })
    .map((subscription) => {
      return (
        <SubscriptionItem
          key={uuid4()}
          subscriptionKey={subscription.key}
          name={subscription.provider.name ?? null}
          email={subscription.provider.email}
          description={subscription.provider.description || text.MOASHELF.PROVIDER_DESCRIPTION_NOTIFICATION}
          publishDays={subscription.provider.publishDays || []}
          isBookmark={subscription.isBookmark}
          trashedAt={subscription.trashedAt ?? ''}
        />
      );
    });

  return (
    <Wrapper>
      {/* TODO: Naivigator 높이만큼 빼기 */}
      <Scroll direction='y' height={isMobile ? '100%' : '100%'}>
        {SubscriptionItems.length > 0 ? (
          <SubscriptionItemsContainer>{SubscriptionItems}</SubscriptionItemsContainer>
        ) : (
          <TextBlock text={notificationText} design={TEXT_DESIGN} />
        )}
      </Scroll>
    </Wrapper>
  );
};

export default Subscriptions;
